module.exports = __webpack_public_path__ + "img/camper_exteriour_2.012e94d2.jpg";